import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function RealPropertySection({ items, caseId, onAdd, onEdit, onDelete }) {
  return (
    <section className="space-y-8 mt-12">
      <header className="flex items-center justify-between bg-gray-100 p-4 rounded-md">
        <h2 className="text-2xl font-semibold">Real Property</h2>
        <button
          onClick={onAdd}
          className="px-4 py-1 bg-blue-600 text-white rounded"
        >
          Add Real Property
        </button>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(item => (
          <div key={item.id} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow flex flex-col">
            <h3 className="text-lg font-semibold mb-2">
              {item.street1}{item.street2 ? `, ${item.street2}` : ''}, {item.city}, {item.state} {item.zip_code}
            </h3>
            <ul className="space-y-1 text-sm text-gray-700 mb-4">
              <li><strong>Type:</strong> {item.property_type}</li>
              <li><strong>Ownership:</strong> {item.ownership_type}</li>
              <li><strong>Exemption Code:</strong> {item.exemption_code || '–'}</li>
              <li><strong>Exemption Amt:</strong> ${item.exemption_amount ?? '0.00'}</li>
            </ul>
            <div className="mt-auto flex space-x-2">
              <button
                onClick={() => onEdit(item)}
                className="px-3 py-1 bg-yellow-500 text-white rounded"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(item.id)}
                className="px-3 py-1 bg-red-600 text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

RealPropertySection.propTypes = {
  items: PropTypes.array.isRequired,
  caseId: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
